<template>
<div>
  <vb-form-row item-name="メールアドレス" :required="true">
    <template #input>
      <v-sheet class="col-12 pa-0" max-width="400">
        <validation-provider v-slot="{ errors }" name="メールアドレス" :rules="emailValidRule"
          mode="passive" ref="email">
          <v-text-field
            type="email"
            v-model="returnFormattedEmailAddress"
            @blur="
              $refs.email.validate(); 
              blurBgColorChange($event, errors[0])"
            @focus="focusBgColorChange($event, errors[0])"
            :error-messages="errors"
            outlined
            required
            dense
            height="44px"
            :background-color="errors[0] ? 'red lighten-5' : 'accent2'"
            autocomplete="new-password"
            name="email"
            hide-details="auto"
            solo
            flat
            :maxlength="emailAddressMaxLength"
          >
            <template #label><span class="text-body-2">example@value-books.jp</span></template>
          </v-text-field>
          <slot name="email-annotation"/>
        </validation-provider>
      </v-sheet>
    </template>
  </vb-form-row>
</div>
</template>

<script>
import VbFormRow from "../buy/vb-form-row.vue";
import formConfig from "../../../config/form.js";
import InputValueConversion from '../../../libs/InputValueConversion.js';

export default {
  name: "vb-mail-address",
  components: {VbFormRow},
  props: {
    formItemsSetter: {
      type: Function,
      required: true
    },
    formItemsGetter: {
      type: Object,
      required: true,
      default: {}
    },
  },
  data() {
    return {
      emailAddressMaxLength: formConfig.emailAddressMaxLength,
    }
  },
  methods: {
    focusBgColorChange(event, errors) {
      const targetNode = event.target.parentNode.parentNode;
      if (event.target.value === "") {
        targetNode.classList.add('input-bg-white');
      }
    },
    blurBgColorChange(event, errors) {
      const targetNode = event.target.parentNode.parentNode;
      if (errors) {
        targetNode.classList.remove('input-bg-white');
      }
    },
    toHalfSize(value) {
      if(!!value){
        return InputValueConversion.toHalfSize(value);
      }
    },
  },
  computed: {
    isAgreedCreateMainSiteAccountBySiteCode() {
      if (this.$siteCode === VueConfig.siteCode.valuebooks) {
        return true
      }
      return this.formItemsGetter.isAgreedCreateMainSiteAccount
    },
    emailValidRule() {
      return {
        required: true,
        email_character: true,
        email_format: this.isAgreedCreateMainSiteAccountBySiteCode,
        max: this.emailAddressMaxLength
      }
    },
    returnFormattedEmailAddress: {
      get() {
        return this.formItemsGetter.email
      },
      set(value) {
        this.formItemsSetter({name: 'email', value: this.toHalfSize(value)})
      }
    },
  }
}
</script>

<style scoped>

</style>